import { Text } from "@clipboard-health/ui-react";
import { Box, Skeleton } from "@mui/material";
import { useAgentProfile } from "@src/appV2/Agents/api/useAgentProfile";
import { formatCentsAsUsd } from "@src/appV2/lib/Money/utils/currency";

import { useGetAutoBookGuaranteedRate } from "../../hooks/useGetAutoBookGuaranteedRate";

export function WorkerAutoBookInfo() {
  const { data: agentProfile, isLoading } = useAgentProfile();
  const rateResult = useGetAutoBookGuaranteedRate({
    agentQualifications: agentProfile?.licensesData?.map((license) => license.qualification) ?? [],
    agentMetropolitanStatisticalArea: agentProfile?.address?.metropolitanStatisticalArea ?? "",
  });

  return (
    <Box>
      <Text bold variant="h3">
        Auto-Book
      </Text>
      <Text>
        By enabling auto-book, workplaces will be able to directly book you into a shift as long as
        it meets your criteria above. As soon as a workplace auto-books you, the shift is yours and
        you will be notified by text.&nbsp;
        {isLoading && <Skeleton animation="wave" />}
        {!isLoading && (
          <b>
            {rateResult.guaranteedRate
              ? `All auto-book shifts are guaranteed a rate of at least ${formatCentsAsUsd(
                  rateResult.guaranteedRate.amountInMinorUnits
                )}/hr.`
              : "All auto-book shifts are guaranteed a rate of at least the average in this area."}
          </b>
        )}
      </Text>
    </Box>
  );
}
